(function () {
    'use strict';

    angular
        .module('app.unitmeasures')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'unitmeasures',
                config: {
                    url: '/unitmeasures',
                    title: 'Birimler',
                    abstract: true,
                    templateUrl: 'app/unitmeasures/unitmeasures.html'
                }
            },
            {
                state: 'unitmeasures.list',
                config: {
                    templateUrl: 'app/unitmeasures/unitmeasures.list.html',
                    controller: 'UnitmeasureListController',
                    controllerAs: 'vm',
                    url: '/list',
                    title: 'Marka Listesi',
                    settings: {
                        nav: 4,
                        name: 'unitmeasures.list',
                        topName: 'products',
                        content: 'Marka Listesi',
                        resource: 'menu.unitmeasures.list'
                    }
                }
            }
        ];
    }
})();